export default __webpack_public_path__ + "static/media/signOut.99d8733f.svg";